import { PathLike } from 'fs';
import { access } from 'fs/promises';

export class FileSystemUtility {
  public static async exists(path: PathLike): Promise<boolean> {
    try {
      await access(path);
      return true;
    } catch {
      return false;
    }
  }
}
